// extracted by mini-css-extract-plugin
module.exports =  {"input-slider":"_0d624b9a27--input-slider--g0OCl","slider":"_0d624b9a27--slider--Sadzu","input":"_0d624b9a27--input--YmTjn"};